export default () => ({
  requestStatus: null,
  data: {},
  otpData: {},
  publicKeyData: {},
  isFetching: false,
  savedPayload: {},
  regMobileData: {},
  myInfoDetails: {},
  isMobileNumberUpdated: false,
  memberId: null,
  existingMemberId: null,
  currentStep: 0,
  stepperMaxLength: 3,
  signUpMobile: null,
});
